import React, { useState } from "react";
import { useSelector } from "react-redux";
import Properties from "./Properties";
import ChecklistSidePanel from "./ChecklistSidePanel";
import MaintenanceSidePanel from "../maintenance/MaintenanceSidePanel";

const ChecklistProxy = () => {
  return (
    <div>
      {/* <h2>Checklist Component</h2> */}
      {/* Add your checklist component content here */}
    </div>
  );
};

const ObjectInterface = () => {
  const [activeTab, setActiveTab] = useState("properties");
  const { selectedObjectData } = useSelector((state) => state.modelReducer);

  return (
    <div>
      {selectedObjectData && (
        <div className="d-flex align-items-center">
          Selected tag number: {selectedObjectData.tag}
        </div>
      )}
      {/* <div className="me-auto">
        <button
          className={"btn btn-sm " + (activeTab == "properties" ? " btn-info " : " btn-primary ")}
          onClick={() => {
            setActiveTab("properties");
          }}>
          Properties
        </button>
        <button
          className={"btn btn-sm " + (activeTab == "checklist" ? " btn-info " : " btn-primary ")}
          onClick={() => {
            setActiveTab("checklist");
          }}>
          Checklists
        </button>
        <button
          className={"btn btn-sm " + (activeTab == "maintenance" ? " btn-info " : " btn-primary ")}
          onClick={() => {
            setActiveTab("maintenance");
          }}>
          Maintenance
        </button>
      </div> */}
      {selectedObjectData && (
        <div className="tab-content">
          {activeTab === "properties" && <Properties />}
          {activeTab === "checklist" && <ChecklistSidePanel />}
          {activeTab === "maintenance" && <MaintenanceSidePanel />}
        </div>
      )}
    </div>
  );
};

export default ObjectInterface;
